import React, { useState, useEffect, useRef } from 'react';
import Input from '../input/Input';
import axios from 'axios';
import css from "./AutoCompleteAdress.module.scss"

const MIN_QUERY_LENGTH = 3;
const FETCH_INTERVAL = 250;
const SUGGESTIONS_LIMIT = 8;

const AutoCompleteAddress = ({ name, label, onSelect, value, type , onChange,  isPreFilled , ...props }) => {
  const [query, setQuery] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSelected, setIsSelected] = useState( isPreFilled ||  false); // if the value is pre-filled do not open the dropdown
  const dropdownRef = useRef(null);
  const lastFetchRef = useRef(0);


  const extractBeforeNumber = (str) => {
    const match = str.match(/^(.*?)\s\d+/);
    return match ? match[1].trim() : str;
  };

  useEffect(() => {
    if (query.length < MIN_QUERY_LENGTH || isSelected) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    const controller = new AbortController();

    const fetchAddresses = async () => {
      lastFetchRef.current = Date.now();
      try {
        const response = await axios.get(
          `https://api-adresse.data.gouv.fr/search/?q=${query}&type=${type || "" }&limit=${SUGGESTIONS_LIMIT}`,
          { signal: controller.signal }
        );
        let formattedSuggestions = response.data.features.map((item) => ({
          value: item.properties.name,
          label: item.properties.label,
          postalCode: item.properties.postcode,
          city: item.properties.city,
        }));
        setSuggestions(formattedSuggestions);
        setShowDropdown(formattedSuggestions.length > 0);
      } catch (error) {
        if (axios.isCancel(error) || error.name === 'CanceledError') {
          return;
        }
        console.error('Error fetching address suggestions:', error);
      }
    };

    const sinceLastFetch = Date.now() - lastFetchRef.current;
    const wait = sinceLastFetch >= FETCH_INTERVAL ? 0 : FETCH_INTERVAL - sinceLastFetch;
    const timer = setTimeout(fetchAddresses, wait);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [query, isSelected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>

      <Input
        name={name}
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          onChange(e);
          setIsSelected(false);
        }}
        placeholder={label}
        className="input"
        onFocus={() => setShowDropdown(true)}
        {...props}
      />


      {showDropdown && suggestions.length > 0 && (
        <ul className={css.dropdown}>
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              className={css.dropdown__item}
              onClick={() => {
                const value = type === "municipality" ? extractBeforeNumber(suggestion.label) :  suggestion.value;
                setQuery(value);
                onSelect({ city: suggestion.city, postalCode: suggestion.postalCode , value : value});
                setShowDropdown(false);
                setIsSelected(true);
              }}
            >
              {suggestion.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteAddress;
